const initialState = {};

function reducer(state = initialState, action) {
    switch (action.type) {
        case "benefitCode":
            return Object.assign({}, state, action.data);

        default:
            return state;
    }
}

const data = {
    name: "benefitCode",
    reducer: reducer,
};

export default data;